import React, { useState } from "react";
import View from "components/presentation/history/History.view";

function History({ 
  notesRef,
  flow, 
  chat, 
  selectedNote,
  isAdmin,
  onClickChangeChat,
  onClickSelectNote,
}) {

  const [historyTab, setHistoryTab] = useState("chats");

  const onClickTab = tabName =>
    setHistoryTab(tabName)

  return (
    <View
      notesRef={notesRef}
      flow={flow}
      chat={chat}
      selectedNote={selectedNote}
      isAdmin={isAdmin}
      historyTab={historyTab}
      onClickChangeChat={onClickChangeChat}
      onClickSelectNote={onClickSelectNote}
      onClickTab={onClickTab}
    />
  );
}

export default History;